'use client';
import useFeatureContent from '@/hooks/useFeatureContent';
import { NavMenuItem, NavMenuItemProps } from './NavMenuItem';

export const VariationMenuItem = ({
  menuItem,
  i,
  user,
  logoutText,
  onClickSignOut,
}: NavMenuItemProps) => {
  const content = useFeatureContent({ ...menuItem.fields });
  if (!content) return null;

  return (
    <NavMenuItem
      menuItem={content}
      {...{ i, user, logoutText, onClickSignOut }}
    />
  );
};
